import { Component, OnInit, ViewChild, Input } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';



@Component({
  selector: 'printfooterview',
  templateUrl: './printfooterview.component.html',
  styleUrls: ['./printfooterview.component.scss']
})

export class  PrintfooterviewComponent implements OnInit {
  
  public Date: Date;


  @Input() Sign1: string;
  @Input() Sign2: string;
  @Input() FpSign1: string;
  @Input() FpSign2: string;
 
  constructor(private route: ActivatedRoute, private router: Router,) { }


  ngOnInit() {

    this.Date = new Date();
  }
  

 
 
 


 
}
